import { filterApiHeaders } from '../filter-api-headers';
import { getHeaders } from '../get-headers';
export const createFetchOptions = (details, apiConfig = {}, apiHeader) => {
    return Object.assign(Object.assign({}, details.options), { headers: Object.assign(Object.assign(Object.assign({}, getHeaders(apiConfig)), (details.options && details.options.body
            ? {
                'content-type': 'application/json',
            }
            : {})), filterApiHeaders(apiHeader)), mode: 'cors', redirect: 'error' });
};
